//TODO Подумать над тем что бы вынести все кнопки в bidOperations

import { Alert, Card, Divider, Flex, Spin, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useStores } from "stores";
import { BidHeader } from "./BidHeader";
import { BidOperations } from "./BidOperations";
import { BidTopAlerts } from "./BidTopAlerts";
import { BidInfoBlocks } from "./BidInfoBlocks";
// import { SpeedUpTransactionButton } from "./SpeedUpTransaction";
import {
  BID_REQUEST_STATUS_ENUM,
  BID_REQUEST_TYPE_ENUM,
  BidWalletCheckGridDto,
  NOTIFICATION_TYPE_ENUM,
  QUOTE_SELECTION_ENUM,
  RISK_STATUS_ENUM,
} from "interfaces";
import { BidStepsContainer } from "./BidSteps";
import {
  checkDaysPassed,
  isStatusEarlierThan,
  isStatusIncluded,
  isStatusLaterOrEqualThan,
  parseErrorMessage,
  notificationPeriodDays,
} from "utils";
import { getBidWalletCheckList, getStatusMessage } from "services";
import { BidInfoTabs } from "./BidInfoTabs";

import { DIRECT_PAYMENT_CUSTOMER_LP, EXECUTION_CHECK_EXPIRATION, QUOTE_SELECTION, SAFE_DEAL } from "utils/envConstants";
import { BidCloseAlert } from "./BidCloseAlert";

import { useNotificationContext } from "providers";
import { ApproveAllRisksBtn } from "./ApproveAllRisksBtn/ApproveAllRisksBtn";
import { CancelBidButton } from "./BidOperations/CancelBid";
import { StopDealButton } from "./BidOperations/StopDeal/StopDealButton";
import { StopCollectQuoteButton } from "./Quotes/StopCollectQuote";
import { RefundCurrencyButton } from "./BidOperations/RefundCurrency";
import { StepBackButton } from "./BidOperations/StepBack/StepBackButton";
import { ErrorCard } from "ui";
import { routes } from "constants/routes";

export const BidInfoPage = observer(() => {
  const { id } = useParams();
  const { bidCard, user, quotes, bidTransactions, bidWalletChecks } = useStores();
  const navigate = useNavigate();

  const { status, contract, statusDate, destinationWallet, transitWallet, type, requestProcessing, balance } =
    bidCard.bid;

  const {
    isSeniorLP,
    isJuniorLP,
    isLPRiskManager,
    isRiskManager,
    isSeniorOperator,
    isJuniorOperator,
    isCustomer,
    isProvider,
    isSeniorCustomer,
    isJuniorCustomer,
  } = user.roles;
  const isProviderOrLPRiskManager = isProvider || isLPRiskManager;

  const { openNotification } = useNotificationContext();

  const [canDisplayBids, setCanDisplayBids] = useState(false);

  const [walletChecks, setWalletChecks] = useState<BidWalletCheckGridDto[]>([]);
  const [walletChecksLoading, setWalletChecksLoading] = useState(true);

  const isOperator = isSeniorOperator || isJuniorOperator;

  const unclosedDays = checkDaysPassed(bidCard.bid.created).days;

  const isBidCloseAlertShow =
    checkDaysPassed(bidCard.bid.created, notificationPeriodDays).isOverDays &&
    !isStatusIncluded(status, [
      BID_REQUEST_STATUS_ENUM.COMPLETED,
      BID_REQUEST_STATUS_ENUM.CANCELED,
      BID_REQUEST_STATUS_ENUM.CANCELED_REFUNDED,
      BID_REQUEST_STATUS_ENUM.CANCELED_REFUNDING,
      BID_REQUEST_STATUS_ENUM.AML_FAILED,
      BID_REQUEST_STATUS_ENUM.AML_FAILED_REFUNDED,
      BID_REQUEST_STATUS_ENUM.AML_FAILED_REFUNDING,
    ]);

  const isCustomerBidStatusNew = isCustomer && QUOTE_SELECTION === QUOTE_SELECTION_ENUM.CUSTOMER && status === "NEW";

  useEffect(() => {
    if (id) {
      if (bidCard.bid.id !== id) {
        bidCard.clear();
        setCanDisplayBids(false);
      }

      const fetchCardInterval = setInterval(() => {
        if (
          bidCard.bid.status === BID_REQUEST_STATUS_ENUM.CANCELED ||
          bidCard.bid.status === BID_REQUEST_STATUS_ENUM.COMPLETED
        ) {
          if (fetchCardInterval) {
            clearInterval(fetchCardInterval);
          }
        } else {
          bidCard.updateCardById(id);
        }
      }, 30000);

      bidCard.fetchCardById(id).then(() => {
        if (bidCard.bid.id === id) {
          quotes.setBidId(bidCard.bid.id);
          bidTransactions.setId(bidCard.bid.id);
          bidWalletChecks.setId(bidCard.bid.id);
          bidTransactions.fetch({ isSilent: true });
          if (!(isCustomer && QUOTE_SELECTION === QUOTE_SELECTION_ENUM.OPERATOR)) {
            quotes.fetch();
          }
          if (!isCustomer && !isProviderOrLPRiskManager) {
            bidWalletChecks.fetch({ isSilent: true });
          }
          setCanDisplayBids(true);
        }
      });

      return () => {
        bidCard.stopPolling();
        bidWalletChecks.clear();
        bidTransactions.clear();
        quotes.clear();
        if (fetchCardInterval) {
          clearInterval(fetchCardInterval);
        }
        bidCard.clear();
        quotes.clear();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, bidCard]);

  const showActivateBidButton =
    (isJuniorOperator || isSeniorOperator) &&
    (status === BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL_ACCEPTED ||
      (status === BID_REQUEST_STATUS_ENUM.DRAFT && type === BID_REQUEST_TYPE_ENUM.REQUEST_WITHOUT_AGENT));

  const showExecuteBidBlock =
    (isSeniorOperator || isJuniorOperator || isRiskManager) && status === BID_REQUEST_STATUS_ENUM.FUNDED;

  const showExecuteBidButtons = (isSeniorOperator || isJuniorOperator) && status === BID_REQUEST_STATUS_ENUM.FUNDED;

  //TODO: удалить если больше не актульно - тк теперь проверяем amlCheckStatusData внутри компонента ExecuteBidBlock
  const loadWalletChecks = useCallback(async () => {
    if (bidCard.bid.id) {
      setWalletChecksLoading(true);
      await getBidWalletCheckList({ id: bidCard.bid.id }, { size: 100, sort: ["created,desc"] })
        .then((res) => {
          setWalletChecks(res.content || []);
        })
        .catch((error) => {
          setWalletChecks([]);
        })
        .finally(() => setWalletChecksLoading(false));
    }
  }, [bidCard.bid.id]);

  useEffect(() => {
    if (
      (showExecuteBidBlock || (showActivateBidButton && contract.direction === "IMP")) &&
      (isRiskManager || isSeniorOperator || isJuniorOperator)
    ) {
      loadWalletChecks();
    }
  }, [
    loadWalletChecks,
    isJuniorOperator,
    isRiskManager,
    isSeniorOperator,
    showExecuteBidBlock,
    showActivateBidButton,
    contract.direction,
  ]);

  const isValidWalletCheck = (walletCheck: BidWalletCheckGridDto) => {
    const now = new Date();
    const bidStatusDate = new Date(statusDate);
    const expirationMinutes = parseInt(EXECUTION_CHECK_EXPIRATION, 10);
    const expirationThreshold = new Date(now.getTime() - expirationMinutes * 60 * 1000);

    const walletCheckTime = new Date(walletCheck.created);

    const isFresh = walletCheckTime > bidStatusDate && walletCheckTime > expirationThreshold;
    const hasRiskStatus = !!walletCheck.riskStatus;
    const isApprovalNeeded = walletCheck.riskStatus === RISK_STATUS_ENUM.APPROVE_NEEDED;

    return {
      isValid: isFresh && hasRiskStatus && !isApprovalNeeded,
      hasApprovalNeeded: isFresh && hasRiskStatus && isApprovalNeeded,
    };
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getValidWalletsChecks = () => {
    if (!destinationWallet || !transitWallet || !statusDate || walletChecksLoading) {
      return { isValid: false, hasApprovalNeeded: false, lastCheckTime: null };
    }

    const destinationWalletCheck = walletChecks.find((check) => check.address === destinationWallet);
    const transitWalletCheck = walletChecks.find((check) => check.address === transitWallet);

    if (!destinationWalletCheck || !transitWalletCheck) {
      return { isValid: false, hasApprovalNeeded: false, lastCheckTime: null };
    }

    const transitResult = isValidWalletCheck(transitWalletCheck);
    const destinationResult = isValidWalletCheck(destinationWalletCheck);

    const destinationCheckTime = new Date(destinationWalletCheck.created).getTime();
    const transitCheckTime = new Date(transitWalletCheck.created).getTime();
    const lastCheckTime = new Date(Math.max(destinationCheckTime, transitCheckTime));

    return {
      isValid: transitResult.isValid && destinationResult.isValid,
      hasApprovalNeeded: transitResult.hasApprovalNeeded || destinationResult.hasApprovalNeeded,
      lastCheckTime,
    };
  };

  const validWalletsChecks = useMemo(() => {
    return getValidWalletsChecks();
  }, [getValidWalletsChecks]);

  const showOfferButton = (isSeniorLP || isJuniorLP) && status === BID_REQUEST_STATUS_ENUM.NEW;
  const showQuotesGrid =
    (((isSeniorLP || isJuniorLP || isLPRiskManager) &&
      !isStatusEarlierThan(status, BID_REQUEST_STATUS_ENUM, BID_REQUEST_STATUS_ENUM.NEW)) ||
      ((isSeniorOperator || isJuniorOperator || isRiskManager) &&
        !isStatusIncluded(status, [
          BID_REQUEST_STATUS_ENUM.DRAFT,
          BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL,
          BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL_ACCEPTED,
        ]))) &&
    canDisplayBids;

  // const showSpeedUpTransactionButton =
  //   pendingOutgoingTx &&
  //   splitCount === 1 &&
  //   (isSeniorOperator || isRiskManager) &&
  //   isStatusIncluded(status, [
  //     BID_REQUEST_STATUS_ENUM.EXECUTION,
  //     BID_REQUEST_STATUS_ENUM.AML_FAILED_REFUNDING,
  //     BID_REQUEST_STATUS_ENUM.CANCELED_REFUNDING,
  //   ]);

  const showCancelBidBtnForCustomer =
    (isSeniorCustomer || isJuniorCustomer) &&
    isStatusIncluded(status, [
      BID_REQUEST_STATUS_ENUM.DRAFT,
      BID_REQUEST_STATUS_ENUM.DRAFT_APPROVED,
      BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL,
      BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL_ACCEPTED,
      BID_REQUEST_STATUS_ENUM.NEW,
      BID_REQUEST_STATUS_ENUM.QUOTE_PROPOSED,
    ]);

  const showCancelBidBtnForOperator =
    (isSeniorOperator || isJuniorOperator) &&
    isStatusIncluded(status, [
      BID_REQUEST_STATUS_ENUM.DRAFT,
      BID_REQUEST_STATUS_ENUM.DRAFT_APPROVED,
      BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL,
      BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL_ACCEPTED,
      BID_REQUEST_STATUS_ENUM.NEW,
      BID_REQUEST_STATUS_ENUM.QUOTE_PROPOSED,
      BID_REQUEST_STATUS_ENUM.FUNDING,
      BID_REQUEST_STATUS_ENUM.AML_FAILED,
    ]);

  const showCancelBidButton = showCancelBidBtnForCustomer || showCancelBidBtnForOperator;

  const showStopDealButton =
    isRiskManager &&
    status === BID_REQUEST_STATUS_ENUM.FUNDING &&
    ((requestProcessing.fiatSent && requestProcessing.fiatReceived) || !requestProcessing.fiatSent);

  const showRefundButton =
    isRiskManager &&
    isStatusIncluded(status, [
      BID_REQUEST_STATUS_ENUM.CANCELED,
      BID_REQUEST_STATUS_ENUM.CANCELED_REFUNDING,
      BID_REQUEST_STATUS_ENUM.AML_FAILED,
      BID_REQUEST_STATUS_ENUM.AML_FAILED_REFUNDING,
      BID_REQUEST_STATUS_ENUM.COMPLETED,
    ]) &&
    balance?.token &&
    +balance.token > 0;

  const showStepBackButton =
    (isSeniorCustomer &&
      isStatusIncluded(status, [
        BID_REQUEST_STATUS_ENUM.QUOTE_PROPOSED,
        BID_REQUEST_STATUS_ENUM.EXPIRED,
        BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL,
      ])) ||
    ((isSeniorOperator || isRiskManager) &&
      isStatusIncluded(status, [BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL_ACCEPTED]));

  //Кнопка отмены котировки
  const showButtonCancelQuote =
    isStatusIncluded(status, [BID_REQUEST_STATUS_ENUM.NEW]) &&
    user.roles.isCustomer &&
    !bidCard.bid.collectQuotesImmediately;

  const isCustomerSafeDeal = isCustomer && SAFE_DEAL && contract.direction === "EXP";

  const showBankDetailsForFundingLp = isProviderOrLPRiskManager && status === BID_REQUEST_STATUS_ENUM.FUNDING;
  const showBankDetailsForOtherRoles =
    ((isCustomer && !isCustomerSafeDeal) || (isOperator && !DIRECT_PAYMENT_CUSTOMER_LP)) &&
    isStatusLaterOrEqualThan(status, BID_REQUEST_STATUS_ENUM, BID_REQUEST_STATUS_ENUM.FUNDING);

  const showBankDetails =
    (showBankDetailsForFundingLp || showBankDetailsForOtherRoles) &&
    status !== BID_REQUEST_STATUS_ENUM.CANCELED &&
    status !== BID_REQUEST_STATUS_ENUM.CANCELED_REFUNDING &&
    status !== BID_REQUEST_STATUS_ENUM.CANCELED_REFUNDED;

  const showTransactionList =
    (isStatusLaterOrEqualThan(status, BID_REQUEST_STATUS_ENUM, BID_REQUEST_STATUS_ENUM.FUNDING) &&
      isProviderOrLPRiskManager) ||
    (isStatusLaterOrEqualThan(status, BID_REQUEST_STATUS_ENUM, BID_REQUEST_STATUS_ENUM.DRAFT) &&
      (isCustomer || isSeniorOperator || isJuniorOperator || isRiskManager));

  const amlCheckStatus = bidCard.amlCheckStatusData?.some((i) => !i.checksSuccess && i.checksCompleted);

  const checkApproveNeededTransactions = bidTransactions.allData.some(
    (i) => i.riskStatus === RISK_STATUS_ENUM.APPROVE_NEEDED && i.currency === "TOKEN" && i.type === "IN"
  );

  const checkApproveNeededWallets = bidWalletChecks.allData.some(
    (i) => i.riskStatus === RISK_STATUS_ENUM.APPROVE_NEEDED
  );

  const showApproveAllRiskBtn =
    isRiskManager && amlCheckStatus && (checkApproveNeededTransactions || checkApproveNeededWallets);

  useEffect(() => {
    const fetchAmlStatus = async () => {
      try {
        await bidCard.fetchAmlCheckStatus(bidCard.bid.id);
      } catch (error: any) {
        openNotification({
          message: error.title,
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
      }
    };

    if (bidCard.bid.id && !isProviderOrLPRiskManager) {
      fetchAmlStatus();
    }
  }, [bidCard.bid]);

  const hasPlError = isProvider && bidCard.fetchError?.code === "400";

  return bidCard.isPending ? (
    <Flex justify="center" align="center" style={{ height: "80vh" }}>
      <Spin />
    </Flex>
  ) : (
    <>
      {bidCard.fetchStatus === "success" && (
        <Flex vertical gap="middle">
          <Flex vertical className="margin-top-xs">
            <BidHeader />
          </Flex>
          <Divider className="margin-top-none margin-bottom-none" />
          <Flex gap="large" justify="space-between" align="center">
            <Flex vertical gap="small" className="flex-grow">
              {/* {showSpeedUpTransactionButton && (
            <Flex gap="middle" align="center">
              <Alert message={`Транзакция задерживается из-за высокой загрузки сети`} type="warning" showIcon />
              <SpeedUpTransactionButton />
            </Flex>
          )} */}
              <Flex gap={10}>
                <BidTopAlerts data={bidCard.bid} />
              </Flex>
              {(isSeniorOperator || isCustomer) && isBidCloseAlertShow && (
                <BidCloseAlert days={unclosedDays} isOperator={isSeniorOperator} />
              )}
            </Flex>

            <Flex gap="small" justify="end" align="end">
              <BidOperations
                validWalletsChecks={{ ...validWalletsChecks, walletChecks }}
                onWalletChecksUpdated={loadWalletChecks}
                visibleButtons={{
                  showActivateBidButton,
                  showExecuteBidButtons,
                }}
                id={id || ""}
              />
            </Flex>
          </Flex>

          {canDisplayBids && (
            <BidStepsContainer>
              <BidInfoBlocks />
              <BidInfoTabs
                showQuotes={showQuotesGrid || isCustomerBidStatusNew}
                showBankDetails={showBankDetails}
                showWalletCheck={isOperator || isRiskManager}
                showTransactionList={showTransactionList}
                onWalletChecksUpdated={loadWalletChecks}
              />
              <Flex gap="small" wrap="wrap" justify="space-between">
                <Flex gap="small" wrap="wrap">
                  {showApproveAllRiskBtn && <ApproveAllRisksBtn />}
                  {showRefundButton && <RefundCurrencyButton />}
                </Flex>
                <Flex gap="small" wrap="wrap">
                  {showStepBackButton && <StepBackButton />}
                  {showCancelBidButton && <CancelBidButton />}
                  {showStopDealButton && <StopDealButton />}
                  {showButtonCancelQuote && <StopCollectQuoteButton />}
                </Flex>
              </Flex>
            </BidStepsContainer>
          )}
        </Flex>
      )}
      {bidCard.fetchError && bidCard.fetchStatus === "error" && (
        <Flex justify="center" align="center" style={{ height: "80vh" }}>
          <ErrorCard
            status={bidCard.fetchError.status}
            description={hasPlError ? { ...bidCard.fetchError, message: "Доступ запрещен" } : bidCard.fetchError}
            buttonText="Вернуться к списку заявок"
            fn={() => navigate(routes.bids)}
          />
        </Flex>
      )}
    </>
  );
});
